/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import PauseIcon from "dc-icons/viewer2021/SDC_Pause_18_N.svg";
import PlayIcon from "dc-icons/viewer2021/SDC_Play_18_N.svg";
import { isReadAloudPausedByButton } from "selectors/readAloudSelectors";
import ReadAloudCss from "components/readAloud/readAloud.css";
import { getFocusElementCallback } from "selectors/accessibilitySelectors";

const mapStoreToProps = stores =>
  isReadAloudPausedByButton(stores)
    ? {
        icon: PlayIcon,
        className: ReadAloudCss.controls,
        clickHandler: () => stores.readAloudStore.playButtonHandler(),
        ariaLabel: "arialabel.readAloudPlay",
        tooltipString: "tooltip.readAloudPlay",
        refCallback: getFocusElementCallback(stores, "PlayPause")
      }
    : {
        icon: PauseIcon,
        className: ReadAloudCss.controls,
        clickHandler: () => stores.readAloudStore.pauseButtonHandler(),
        ariaLabel: "arialabel.readAloudPause",
        tooltipString: "tooltip.readAloudPause",
        refCallback: getFocusElementCallback(stores, "PlayPause")
      };

const ReadAloudPlayPauseContainer = inject(mapStoreToProps)(ButtonWrapper);
export { ReadAloudPlayPauseContainer };
